import produce from "immer";
import { CustomizationState } from "..";
import { OptionsConfiguration } from "../../../types/customization/configuration";
import { checkAndReplaceInvalidPageDefinitions } from "../../../utils/customization/pageDefinition";

export interface VerifyAndReplacePageDefinitionsAction {
  type: "verifyAndReplacePageDefinitions";
  options: OptionsConfiguration[] | undefined;
}

export function verifyAndReplacePageDefinitions(
  state: CustomizationState,
  action: VerifyAndReplacePageDefinitionsAction
): CustomizationState {
  return produce(state, (draftState) => {
    const options = action.options || [];

    checkAndReplaceInvalidPageDefinitions(draftState, options);
  });
}
